import { httpGet, httpPostWithCompanyId } from "../Backend";

const root = 'api/auth'

export interface IAuthConfig {
    domain: string,
    clientId: string,
    audience: string,
    scope: string
    connection: string
}

export default class AuthApi {
    setLoading: any;
    setToastMessage: any;

    constructor(setloading: any, setToastMessage: any) {
        this.setLoading = setloading;
        this.setToastMessage = setToastMessage;
    }

    async ensureCreated(authId: string): Promise<string> {
        this.setToastMessage('Processing')
        this.setLoading(true);
        const result = await httpPostWithCompanyId(`${root}/ensure-created`, { authId });
        this.setLoading(false);
        return result.data;
    }
}

export async function getConfig(): Promise<IAuthConfig> {
    var config = await httpGet(`${root}/config`);
    return config.data;
}

export async function getMyPermissionConfig() {
    var config = await httpGet(`${root}/permissions`);
    return config.data;
}